import { Suspense, lazy } from "react";
import Loader from "@/components/Loader";
import { PATH_PRIVACY_POLICY, PATH_SUPPORT } from "./paths";

// Lazy like every other route module — privacy/support are rarely visited
// and don't belong in the main chunk.
const PrivacyContainer = lazy(() => import("@/pages/privacy"));
const SupportContainer = lazy(() => import("@/pages/support"));

// These routes render outside any layout, so each element carries its own
// Suspense boundary.
const withSuspense = (element: JSX.Element) => (
  <Suspense fallback={<Loader />}>{element}</Suspense>
);

const miscRoutes = [
  {
    path: PATH_PRIVACY_POLICY,
    element: withSuspense(<PrivacyContainer />),
  },
  {
    path: PATH_SUPPORT,
    element: withSuspense(<SupportContainer />),
  },
];

export default miscRoutes;
